import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_CA',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '8199cf0d-6b93-4922-9ef3-eb344e9ac65f',
  ''
);
